export function apiBase(): string {
  const configured = import.meta.env.VITE_API_BASE_URL?.replace(/\/$/, "");
  return configured || `${globalThis.location.origin}/api`;
}
